
// import './css/common.css'
// import './css/modular.css'

// 导入单个组件
// import YnFormSend from "./form_send/index"
// import YnFormDsh from "./form_dsh/index"
// import YnFormSh from "./form_sh/index"
// import YnFormDbl from "./form_dbl/index"
// import YnFormBl from "./form_bl/index"
// import YnFormCs from "./form_cs/index"
// 以数组的结构保存组件，便于遍历
import YnForm from './Form/index'
const components = [
    // YnFormSend,
    // YnFormDsh,
    // YnFormSh,
    // YnFormDbl,
    // YnFormBl,
    // YnFormCs
    YnForm
]

// 定义 install 方法
const install = function (Vue) {
    if (install.installed) return
    install.installed = true
    // 遍历并注册全局组件
    components.map(component => {
        Vue.component(component.name, component)
    })
    
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}

export default {
    // 导出的对象必须具备一个 install 方法
    install,
    // 组件列表
    components
}